import { createAction } from 'redux-action';

export const CHOOSE_TERM = 'addon/term/CHOOSE';

export const chooseTerm = createAction(CHOOSE_TERM);
